//
// Copyright (c) 2020 Astute Global, Inc.
//

define(["marionette", "./template/departmentHistoryModalTemplate.html"], function (
  Marionette,
  DepartmentHistoryModalTemplate,
) {
  "use strict";

  var DepartmentHistoryModalView = {};

  DepartmentHistoryModalView.departmentHistoryModalLayout = Marionette.Layout.extend({
    template: DepartmentHistoryModalTemplate,
    regions: {
      departmentHistory: "#departmentHistory",
    },
    triggers: {
      "click #doneButton": "done",
    },
  });

  return DepartmentHistoryModalView;
});
